import { BaseEvent } from '@packages/shared/core/analytics/events/BaseEvent';
import { BaseEventHandler } from '@packages/shared/core/analytics/events/BaseEventHandler';

export class ConsentSettingsClickedEvent extends BaseEvent {
  constructor() {
    super(null);
  }
}

export class ConsentSettingsClickedEventHandler extends BaseEventHandler {
  shouldTrack(event: BaseEvent): boolean {
    return event instanceof ConsentSettingsClickedEvent;
  }

  async track() {
    return this.amplitudeService.logEvent('consent_settings_clicked');
  }
}
